class AveyShippingDestinations extends HTMLElement {
  connectedCallback() {
    this.picker = this.querySelector('[data-shipping-picker]');
    this.select = this.picker?.querySelector('select');
    this.cards = [...this.querySelectorAll('[data-shipping-country]')];
    if (!this.select || !this.cards.length) return;
    this.updateDestination();
    this.picker.hidden = false;
    this.addEventListener('change', this.onChange);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.onChange);
  }

  onChange = (event) => {
    if (event.target === this.select) this.updateDestination();
  };

  updateDestination() {
    const selected = this.cards.find((card) => card.dataset.shippingCountry === this.select.value);
    if (!selected) return;
    for (const card of this.cards) {
      card.hidden = card !== selected;
      card.classList.toggle('is-current', card === selected);
    }
  }
}

if (!customElements.get('avey-shipping-destinations')) {
  customElements.define('avey-shipping-destinations', AveyShippingDestinations);
}
